import { useRoutes, matchRoutes } from "react-router-dom";
import React, { useEffect, useState } from "react";
// project import
import LoginRoutes from "./LoginRoutes";
import MainRoutes from "./MainRoutes";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { isExpired } from "react-jwt";
import { LOGIN_AUTH, LOGOUT_AUTH } from "store/reducers/auth";
import { pickLandingPath, readStoredAccessList } from "@shared/utils/userRole";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const userModel = useSelector((state) => state.auth.userModel);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    checkLogin();
  }, [userModel.isLogin, location.pathname]);

  const [access_list_data, setaccess_list_data] = useState([]);
  const [refresh, set_refresh] = useState([]);

  useEffect(() => {
    if (userModel.isLogin) {
      const storedData = localStorage.getItem("access_list_data");
      if (storedData) {
        setaccess_list_data(readStoredAccessList());
      } else {
        set_refresh(!refresh);
      }
    }
  }, [refresh, userModel.isLogin]);

  // Recovery: if checkLogin parked us at /no-access (because the access
  // list hadn't been written to localStorage yet at navigation time) but
  // the list has since loaded with real permissions, send the user to
  // their proper landing page instead of leaving them stuck.
  useEffect(() => {
    if (
      userModel.isLogin &&
      location.pathname === "/no-access" &&
      Array.isArray(access_list_data) &&
      access_list_data.length > 0
    ) {
      navigate(pickLandingPath(access_list_data), { replace: true });
    }
  }, [access_list_data, location.pathname, userModel.isLogin]);

  function checkLogin() {
    const token = localStorage.getItem("Token");
    const isMyTokenExpired = isExpired(token);

    if (!userModel.isLogin) {
      if (
        (location.pathname !== "/login" || location.pathname !== "/") &&
        isMyTokenExpired
      ) {
        const loginRoutes = [LoginRoutes()];
        const matchedRoutes = matchRoutes(loginRoutes, location.pathname);
        matchedRoutes
          ? navigate({
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
          })
          : navigate("/login");
        localStorage.setItem("lang", "en");
      }
    } else if (isMyTokenExpired && userModel.isLogin) {
      dispatch(LOGOUT_AUTH());
      navigate("/login");
    } else if (
      (location.pathname === "/login" || location.pathname === "/") &&
      !isMyTokenExpired
    ) {
      dispatch(LOGIN_AUTH());
      // Land on the first module the user can actually see — falls back
      // to /no-access if their role grants zero read permissions.
      navigate(pickLandingPath(readStoredAccessList()));
    } else {
      dispatch(LOGIN_AUTH());
    }
  }

  return useRoutes([
    LoginRoutes(),
    userModel.isLogin && MainRoutes(access_list_data),
  ]);


  function checkLogin() {
    const token            = localStorage.getItem("Token");
    const isMyTokenExpired = isExpired(token);

    if (!userModel.isLogin) {
      if (
        (location.pathname !== "/login" || location.pathname !== "/") &&
        isMyTokenExpired
      ) {
        const loginRoutes   = [LoginRoutes()];
        const matchedRoutes = matchRoutes(loginRoutes, location.pathname);
        matchedRoutes
          ? navigate({
              pathname: location.pathname,
              search:   location.search,
              hash:     location.hash,
            })
          : navigate("/login");
        localStorage.setItem("lang", "en");
      }
    } else if (isMyTokenExpired && userModel.isLogin) {
      dispatch(LOGOUT_AUTH());
      navigate("/login");
    } else if (
      (location.pathname === "/login" || location.pathname === "/") &&
      !isMyTokenExpired
    ) {
      dispatch(LOGIN_AUTH());

      navigate(pickLandingPath(readStoredAccessList()));

    } else {
      dispatch(LOGIN_AUTH());
    }
  }
}
